module.exports = __webpack_public_path__ + "img/21.1.C.6edcaf87.png";